// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any,no-bitwise */ // Big int to [0-1] RGB array
export function intToRgb(int) {
    return [
        (int >> 16 & 255) / 255,
        (int >> 8 & 255) / 255,
        (int & 255) / 255
    ];
}
// Adds a min-max function allowing us to interpolate values between breakpoints
// rather than setting many breakpoints or doing complex calculations each time.
export const stripeStretch = (min, max, screenWidthStart = 375, screenWidthEnd = 1112)=>{
    const calc = `clamp(calc(${min} * 1px + (${max} - ${min}) * ((var(--windowWidth) - ${screenWidthStart} * 1px) / (${screenWidthEnd} - ${screenWidthStart}))), calc(${min} * 1px), calc(${max} * 1px));`;
    return calc;
};
/**
 * Capitalizes the first letter of a given string.
 *
 * @param string - The string to be modified.
 * @returns The string with the first letter capitalized.
 */ export function capitalizeFirstLetter(string) {
    if (string.length === 0) {
        return string;
    }
    const firstChar = string.charAt(0).toUpperCase();
    const restOfString = string.slice(1);
    return firstChar + restOfString;
}

//# sourceMappingURL=utils.js.map